export default "__VITE_ASSET__oT8otXut__"